import styled from 'styled-components';
import { Button, ButtonSizes } from '../../../styles/button';

const JobLinkContainer = styled.div`
    display: flex;
    width: 100%;
    align-items: center;
    justify-content: center;
`;

export default function JobLink({ job }) {

    const getClickableLink = link => {
        return link.startsWith("http://") || link.startsWith("https://") ?
            link
            : `http://${link}`;
    };

    return (
        <JobLinkContainer>
            {
                job.linkToApply != null && job.linkToApply?.length > 0 ?
                    <a href={getClickableLink(job.linkToApply)} target="_blank"
                        rel="noopener noreferrer"
                        aria-label="Berwerbungslink">
                        <Button primary size={ButtonSizes.m}>Jetzt bewerben</Button>
                    </a>
                    :
                    <a href={`mailto:${job.emailContact}`}>
                        <Button primary size={ButtonSizes.m}>Jetzt per E-Mail bewerben</Button>
                    </a>
            }
        </JobLinkContainer>
    )
}
